module.exports = __webpack_public_path__ + "static/media/manage_inventory_icon.0a284fc9.png";